// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   ExaminationOS — Design Tokens
   Deliberately separate from AcademicOS / Bootstrap palette.
   ========================================================= */

:root {
  /* Primary — Amber Gold (academic excellence) */
  --exam-primary:        #D97706;
  --exam-primary-hover:  #B45309;
  --exam-primary-light:  #FEF9EC;
  --exam-primary-muted:  #FDE68A;

  /* Secondary — Emerald */
  --exam-secondary:      #059669;
  --exam-secondary-hover:#047857;
  --exam-secondary-light:#ECFDF5;

  /* Shell — dark sidebar + header */
  --exam-shell-bg:            #0D1B2E;
  --exam-shell-mid:           #162338;
  --exam-shell-hover:         rgba(255, 255, 255, 0.06);
  --exam-shell-active:        rgba(217, 119, 6, 0.18);
  --exam-shell-border:        rgba(255, 255, 255, 0.08);
  --exam-shell-text:          #7F98B6;
  --exam-shell-text-active:   #FFFFFF;
  --exam-shell-accent:        #F59E0B;
  --exam-shell-accent-hover:  #FCD34D;

  /* Neutral surface */
  --exam-bg:             #F4F6F9;
  --exam-surface:        #FFFFFF;
  --exam-surface-hover:  #F1F5F9;
  --exam-surface-alt:    #F8FAFC;
  --exam-border:         #E2E8F0;
  --exam-border-strong:  #CBD5E1;

  /* Text */
  --exam-text:           #0F172A;
  --exam-text-secondary: #475569;
  --exam-text-muted:     #94A3B8;
  --exam-text-inverse:   #FFFFFF;

  /* Semantic */
  --exam-success:        #059669;
  --exam-success-light:  #ECFDF5;
  --exam-warning:        #D97706;
  --exam-warning-light:  #FFFBEB;
  --exam-error:          #DC2626;
  --exam-error-light:    #FEF2F2;
  --exam-info:           #0284C7;
  --exam-info-light:     #F0F9FF;
  --exam-danger:         #DC2626;

  /* Shadows */
  --exam-shadow-xs:  0 1px 2px 0 rgb(0 0 0 / 0.05);
  --exam-shadow-sm:  0 1px 3px 0 rgb(0 0 0 / 0.10), 0 1px 2px -1px rgb(0 0 0 / 0.10);
  --exam-shadow-md:  0 4px 6px -1px rgb(0 0 0 / 0.10), 0 2px 4px -2px rgb(0 0 0 / 0.10);
  --exam-shadow-lg:  0 10px 15px -3px rgb(0 0 0 / 0.10), 0 4px 6px -4px rgb(0 0 0 / 0.10);

  /* Border radius */
  --exam-radius-xs:  4px;
  --exam-radius-sm:  6px;
  --exam-radius:     8px;
  --exam-radius-md:  10px;
  --exam-radius-lg:  12px;
  --exam-radius-xl:  16px;
  --exam-radius-full: 9999px;

  /* Layout */
  --exam-sidebar-width:        240px;
  --exam-sidebar-collapsed:    64px;
  --exam-header-height:        56px;
  --exam-content-max-width:    1280px;

  /* Typography */
  --exam-font:   -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', system-ui, sans-serif;
  --exam-font-mono: 'JetBrains Mono', 'Fira Code', ui-monospace, monospace;

  /* Transitions */
  --exam-transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --exam-transition-slow: 250ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Z-index layers */
  --exam-z-sidebar:  100;
  --exam-z-header:   110;
  --exam-z-dropdown: 200;
  --exam-z-modal:    300;
  --exam-z-toast:    400;
}

/* ── Dark theme ──────────────────────────────────────────────────────────── */
[data-exam-theme="dark"] {
  --exam-bg:             #0F172A;
  --exam-surface:        #1E293B;
  --exam-surface-hover:  #263349;
  --exam-surface-alt:    #172033;
  --exam-border:         #334155;
  --exam-border-strong:  #475569;
  --exam-text:           #F1F5F9;
  --exam-text-secondary: #94A3B8;
  --exam-text-muted:     #64748B;
  --exam-primary-light:  rgba(217,119,6,0.15);
  --exam-primary-muted:  rgba(217,119,6,0.3);
  --exam-success-light:  rgba(5,150,105,0.15);
  --exam-error-light:    rgba(220,38,38,0.15);
  --exam-warning-light:  rgba(217,119,6,0.15);
  --exam-info-light:     rgba(2,132,199,0.15);
  --exam-shadow-xs:      0 1px 2px 0 rgb(0 0 0 / 0.4);
  --exam-shadow-sm:      0 1px 3px 0 rgb(0 0 0 / 0.5), 0 1px 2px -1px rgb(0 0 0 / 0.4);
}

/* ── High contrast theme ─────────────────────────────────────────────────── */
[data-exam-theme="high-contrast"] {
  --exam-bg:             #000000;
  --exam-surface:        #000000;
  --exam-surface-hover:  #1A1A1A;
  --exam-surface-alt:    #0D0D0D;
  --exam-border:         #FFFFFF;
  --exam-border-strong:  #FFFFFF;
  --exam-text:           #FFFFFF;
  --exam-text-secondary: #FFFF00;
  --exam-text-muted:     #CCCCCC;
  --exam-primary:        #FFDD00;
  --exam-primary-hover:  #FFE84D;
  --exam-primary-light:  rgba(255,221,0,0.2);
  --exam-primary-muted:  rgba(255,221,0,0.4);
  --exam-success:        #00FF00;
  --exam-success-light:  rgba(0,255,0,0.15);
  --exam-error:          #FF4444;
  --exam-error-light:    rgba(255,68,68,0.2);
  --exam-shell-bg:       #000000;
  --exam-shell-mid:      #0D0D0D;
  --exam-shell-border:   rgba(255,255,255,0.3);
  --exam-shell-text:     #CCCCCC;
  --exam-shell-accent:   #FFDD00;
}

/* ── Sepia theme ─────────────────────────────────────────────────────────── */
[data-exam-theme="sepia"] {
  --exam-bg:             #F5F0E8;
  --exam-surface:        #FEFCF6;
  --exam-surface-hover:  #EDE8DC;
  --exam-surface-alt:    #F2EDE0;
  --exam-border:         #D4C9B0;
  --exam-border-strong:  #BFB095;
  --exam-text:           #3D2B1F;
  --exam-text-secondary: #6B5040;
  --exam-text-muted:     #9C7B65;
}

/* ── Font size scale ─────────────────────────────────────────────────────── */
[data-exam-fontsize="sm"]  { font-size: 13px; }
[data-exam-fontsize="md"]  { font-size: 14px; }
[data-exam-fontsize="lg"]  { font-size: 15.5px; }
[data-exam-fontsize="xl"]  { font-size: 17px; }

/* ── Dyslexia-friendly font ──────────────────────────────────────────────── */
[data-exam-dyslexia="true"] {
  --exam-font: 'OpenDyslexic', 'Comic Sans MS', 'Arial', sans-serif;
  letter-spacing: 0.05em;
  word-spacing: 0.1em;
}

/* ── Reduced motion ──────────────────────────────────────────────────────── */
[data-exam-reduce-motion="true"] * {
  transition: none !important;
  animation: none !important;
}

/* ── Focus indicators ────────────────────────────────────────────────────── */
[data-exam-focus="enhanced"] :focus-visible {
  outline: 3px solid var(--exam-primary) !important;
  outline-offset: 3px !important;
}
`, "",{"version":3,"sources":["webpack://./src/examination/styles/exam-variables.css"],"names":[],"mappings":"AAAA;;;8DAG8D;;AAE9D;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,qDAAqD;EACrD,mDAAmD;EACnD,qDAAqD;EACrD,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;;EAEnC,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,SAAS;EACT,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,YAAY;EACZ,gDAAgD;EAChD,kFAAkF;EAClF,qFAAqF;EACrF,uFAAuF;;EAEvF,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;;EAE1B,WAAW;EACX,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;;EAEnC,eAAe;EACf,4FAA4F;EAC5F,wEAAwE;;EAExE,gBAAgB;EAChB,qDAAqD;EACrD,0DAA0D;;EAE1D,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,mDAAmD;EACnD,oFAAoF;AACtF;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,0CAA0C;EAC1C,0CAA0C;EAC1C,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,0CAA0C;EAC1C,8BAA8B;EAC9B,8BAA8B;EAC9B,4CAA4C;EAC5C,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,+EAA+E;AAC/E,6BAA6B,eAAe,EAAE;AAC9C,6BAA6B,eAAe,EAAE;AAC9C,6BAA6B,iBAAiB,EAAE;AAChD,6BAA6B,eAAe,EAAE;;AAE9C,+EAA+E;AAC/E;EACE,iEAAiE;EACjE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,+EAA+E;AAC/E;EACE,iDAAiD;EACjD,8BAA8B;AAChC","sourcesContent":["/* =========================================================\n   ExaminationOS — Design Tokens\n   Deliberately separate from AcademicOS / Bootstrap palette.\n   ========================================================= */\n\n:root {\n  /* Primary — Amber Gold (academic excellence) */\n  --exam-primary:        #D97706;\n  --exam-primary-hover:  #B45309;\n  --exam-primary-light:  #FEF9EC;\n  --exam-primary-muted:  #FDE68A;\n\n  /* Secondary — Emerald */\n  --exam-secondary:      #059669;\n  --exam-secondary-hover:#047857;\n  --exam-secondary-light:#ECFDF5;\n\n  /* Shell — dark sidebar + header */\n  --exam-shell-bg:            #0D1B2E;\n  --exam-shell-mid:           #162338;\n  --exam-shell-hover:         rgba(255, 255, 255, 0.06);\n  --exam-shell-active:        rgba(217, 119, 6, 0.18);\n  --exam-shell-border:        rgba(255, 255, 255, 0.08);\n  --exam-shell-text:          #7F98B6;\n  --exam-shell-text-active:   #FFFFFF;\n  --exam-shell-accent:        #F59E0B;\n  --exam-shell-accent-hover:  #FCD34D;\n\n  /* Neutral surface */\n  --exam-bg:             #F4F6F9;\n  --exam-surface:        #FFFFFF;\n  --exam-surface-hover:  #F1F5F9;\n  --exam-surface-alt:    #F8FAFC;\n  --exam-border:         #E2E8F0;\n  --exam-border-strong:  #CBD5E1;\n\n  /* Text */\n  --exam-text:           #0F172A;\n  --exam-text-secondary: #475569;\n  --exam-text-muted:     #94A3B8;\n  --exam-text-inverse:   #FFFFFF;\n\n  /* Semantic */\n  --exam-success:        #059669;\n  --exam-success-light:  #ECFDF5;\n  --exam-warning:        #D97706;\n  --exam-warning-light:  #FFFBEB;\n  --exam-error:          #DC2626;\n  --exam-error-light:    #FEF2F2;\n  --exam-info:           #0284C7;\n  --exam-info-light:     #F0F9FF;\n  --exam-danger:         #DC2626;\n\n  /* Shadows */\n  --exam-shadow-xs:  0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --exam-shadow-sm:  0 1px 3px 0 rgb(0 0 0 / 0.10), 0 1px 2px -1px rgb(0 0 0 / 0.10);\n  --exam-shadow-md:  0 4px 6px -1px rgb(0 0 0 / 0.10), 0 2px 4px -2px rgb(0 0 0 / 0.10);\n  --exam-shadow-lg:  0 10px 15px -3px rgb(0 0 0 / 0.10), 0 4px 6px -4px rgb(0 0 0 / 0.10);\n\n  /* Border radius */\n  --exam-radius-xs:  4px;\n  --exam-radius-sm:  6px;\n  --exam-radius:     8px;\n  --exam-radius-md:  10px;\n  --exam-radius-lg:  12px;\n  --exam-radius-xl:  16px;\n  --exam-radius-full: 9999px;\n\n  /* Layout */\n  --exam-sidebar-width:        240px;\n  --exam-sidebar-collapsed:    64px;\n  --exam-header-height:        56px;\n  --exam-content-max-width:    1280px;\n\n  /* Typography */\n  --exam-font:   -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', system-ui, sans-serif;\n  --exam-font-mono: 'JetBrains Mono', 'Fira Code', ui-monospace, monospace;\n\n  /* Transitions */\n  --exam-transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --exam-transition-slow: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Z-index layers */\n  --exam-z-sidebar:  100;\n  --exam-z-header:   110;\n  --exam-z-dropdown: 200;\n  --exam-z-modal:    300;\n  --exam-z-toast:    400;\n}\n\n/* ── Dark theme ──────────────────────────────────────────────────────────── */\n[data-exam-theme=\"dark\"] {\n  --exam-bg:             #0F172A;\n  --exam-surface:        #1E293B;\n  --exam-surface-hover:  #263349;\n  --exam-surface-alt:    #172033;\n  --exam-border:         #334155;\n  --exam-border-strong:  #475569;\n  --exam-text:           #F1F5F9;\n  --exam-text-secondary: #94A3B8;\n  --exam-text-muted:     #64748B;\n  --exam-primary-light:  rgba(217,119,6,0.15);\n  --exam-primary-muted:  rgba(217,119,6,0.3);\n  --exam-success-light:  rgba(5,150,105,0.15);\n  --exam-error-light:    rgba(220,38,38,0.15);\n  --exam-warning-light:  rgba(217,119,6,0.15);\n  --exam-info-light:     rgba(2,132,199,0.15);\n  --exam-shadow-xs:      0 1px 2px 0 rgb(0 0 0 / 0.4);\n  --exam-shadow-sm:      0 1px 3px 0 rgb(0 0 0 / 0.5), 0 1px 2px -1px rgb(0 0 0 / 0.4);\n}\n\n/* ── High contrast theme ─────────────────────────────────────────────────── */\n[data-exam-theme=\"high-contrast\"] {\n  --exam-bg:             #000000;\n  --exam-surface:        #000000;\n  --exam-surface-hover:  #1A1A1A;\n  --exam-surface-alt:    #0D0D0D;\n  --exam-border:         #FFFFFF;\n  --exam-border-strong:  #FFFFFF;\n  --exam-text:           #FFFFFF;\n  --exam-text-secondary: #FFFF00;\n  --exam-text-muted:     #CCCCCC;\n  --exam-primary:        #FFDD00;\n  --exam-primary-hover:  #FFE84D;\n  --exam-primary-light:  rgba(255,221,0,0.2);\n  --exam-primary-muted:  rgba(255,221,0,0.4);\n  --exam-success:        #00FF00;\n  --exam-success-light:  rgba(0,255,0,0.15);\n  --exam-error:          #FF4444;\n  --exam-error-light:    rgba(255,68,68,0.2);\n  --exam-shell-bg:       #000000;\n  --exam-shell-mid:      #0D0D0D;\n  --exam-shell-border:   rgba(255,255,255,0.3);\n  --exam-shell-text:     #CCCCCC;\n  --exam-shell-accent:   #FFDD00;\n}\n\n/* ── Sepia theme ─────────────────────────────────────────────────────────── */\n[data-exam-theme=\"sepia\"] {\n  --exam-bg:             #F5F0E8;\n  --exam-surface:        #FEFCF6;\n  --exam-surface-hover:  #EDE8DC;\n  --exam-surface-alt:    #F2EDE0;\n  --exam-border:         #D4C9B0;\n  --exam-border-strong:  #BFB095;\n  --exam-text:           #3D2B1F;\n  --exam-text-secondary: #6B5040;\n  --exam-text-muted:     #9C7B65;\n}\n\n/* ── Font size scale ─────────────────────────────────────────────────────── */\n[data-exam-fontsize=\"sm\"]  { font-size: 13px; }\n[data-exam-fontsize=\"md\"]  { font-size: 14px; }\n[data-exam-fontsize=\"lg\"]  { font-size: 15.5px; }\n[data-exam-fontsize=\"xl\"]  { font-size: 17px; }\n\n/* ── Dyslexia-friendly font ──────────────────────────────────────────────── */\n[data-exam-dyslexia=\"true\"] {\n  --exam-font: 'OpenDyslexic', 'Comic Sans MS', 'Arial', sans-serif;\n  letter-spacing: 0.05em;\n  word-spacing: 0.1em;\n}\n\n/* ── Reduced motion ──────────────────────────────────────────────────────── */\n[data-exam-reduce-motion=\"true\"] * {\n  transition: none !important;\n  animation: none !important;\n}\n\n/* ── Focus indicators ────────────────────────────────────────────────────── */\n[data-exam-focus=\"enhanced\"] :focus-visible {\n  outline: 3px solid var(--exam-primary) !important;\n  outline-offset: 3px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
